import React from "react";
import styles from './panel-button.module.css'

export default function PanelButton({imageSrc, onClickFunction, className, ...options}) {
    return (
        <div className={`${styles.panelButton} ${className ? className : ''}`} onClick={onClickFunction} {...options}>
            <img src={imageSrc}></img>
        </div>
    );
}